import { render, staticRenderFns } from "./StudentTicketPage.vue?vue&type=template&id=abb92840&scoped=true&"
import script from "./StudentTicketPage.vue?vue&type=script&lang=js&"
export * from "./StudentTicketPage.vue?vue&type=script&lang=js&"
import style0 from "./StudentTicketPage.vue?vue&type=style&index=0&id=abb92840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb92840",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
